import { Link, Text } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

import styles from './report-sample-link.module.css';

export const ReportSampleLink = ({ link }: { link?: string | null }) => {
  if (link) {
    return (
      <Link
        className={styles['link']}
        fontSize="xs"
        fontWeight="800"
        variant="link"
        as={NavLink}
        to={link || ''}
        whiteSpace="nowrap"
        mr={2}
      >
        View Sample
      </Link>
    );
  } else {
    return (
      <Text className={styles['unavailable']} fontWeight="600" fontSize="xs">
        sample report not available yet
      </Text>
    );
  }
};
